// extracted by mini-css-extract-plugin
export default {"card":"Bag_card__lh7cq","cardbody":"Bag_cardbody__8faAy","container":"Bag_container__14Qe4"};